import { PaymentDetailsMap } from '@zonofi/zono-money-store';
import { PaymentModeType } from '../../constants';
import { defaultPaymentDetails, paymentTypeFields } from '../constant';

export const isSaveButtonDisabled = (
  paymentDetails: PaymentDetailsMap,
  selectedMode: PaymentModeType
): boolean => {
  const modeSpecificFields = paymentTypeFields[selectedMode] || [];

  const allRequiredFields = [
    ...defaultPaymentDetails,
    ...modeSpecificFields,
  ].filter((field) => field.required);

  for (const field of allRequiredFields) {
    const value = paymentDetails[field.key];
    if (!value || String(value).trim() === '') {
      return true;
    }
  }

  return false;
};
